const Permissions = {
  TransactionRequest: {
    Prefix: 'TRANSACTION_REQUEST/PREFIX',
    Export: 'TRANSACTION_REQUEST/EXPORT',
    Approve: 'TRANSACTION_REQUEST/APPROVE',
    Reject: 'TRANSACTION_REQUEST/REJECT',
    // View: 'TRANSACTION_REQUEST/VIEW',
  },
};

export default Permissions;
